import { useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header.jsx';
import Toasts from './components/Toasts.jsx';
import DebugPanel from './components/DebugPanel.jsx';
import Rooms from './pages/Rooms.jsx';
import Room from './pages/Room.jsx';
import Recordings from './pages/Recordings.jsx';
import Settings from './pages/Settings.jsx';
import Login from './pages/Login.jsx';
import { useDebugStore } from './store/debugStore.js';
import { useAuthStore } from './store/authStore.js';
import { LockIcon } from './components/Icons.jsx';

function AppLayout() {
  const debugVisible = useDebugStore((s) => s.enabled);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const loading = useAuthStore((s) => s.loading);
  const checkAuth = useAuthStore((s) => s.checkAuth);

  const location = useLocation();
  const isCall = location.pathname.startsWith('/room/') || location.pathname.startsWith('/join/');

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const handleEnterRoom = (id, role) => {
    window.location.hash = `#/room/${id}${role ? '?role=' + role : ''}`;
  };

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#f4f6f9] text-[#002882] space-y-4">
        <div className="w-12 h-12 rounded-2xl bg-[#002882] text-white flex items-center justify-center shadow-sm animate-pulse">
          <LockIcon size={24} />
        </div>
        <div className="w-8 h-8 rounded-full border-2 border-[#002882]/20 border-t-[#002882] animate-spin" />
        <span className="text-xs font-semibold text-slate-500">Загрузка сервиса…</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <div className={`min-h-screen flex flex-col ${isCall ? 'bg-[#0b1322] text-slate-100 h-[100dvh] overflow-hidden' : 'bg-[#f4f6f9] text-[#191e24]'} selection:bg-primary-500/20 selection:text-primary-700`}>
      {!isCall && <Header onEnterRoom={handleEnterRoom} />}
      <main className={`flex-1 ${isCall ? 'h-full flex flex-col' : ''}`}>
        <Routes>
          <Route path="/" element={<Rooms onEnterRoom={handleEnterRoom} />} />
          <Route path="/rooms" element={<Navigate to="/" replace />} />
          <Route path="/room/:id" element={<Room />} />
          <Route path="/join/:id" element={<Room />} />
          <Route path="/recordings" element={<Recordings />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Toasts />
      <DebugPanel visible={debugVisible} />
    </div>
  );
}

export default function App() {
  return (
    <HashRouter>
      <AppLayout />
    </HashRouter>
  );
}
